import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb from '@/components/feature/Breadcrumb';
import BrandIntro from './components/BrandIntro';
import Reputation from './components/Reputation';
import ContactSection from './components/ContactSection';
import { siteConfig } from '@/mocks/siteConfig';

const jsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: siteConfig.name,
      url: siteConfig.url,
      description: siteConfig.description,
      foundingDate: String(siteConfig.foundingYear),
      email: siteConfig.email,
      contactPoint: {
        '@type': 'ContactPoint',
        email: siteConfig.email,
        contactType: 'customer service',
        availableLanguage: ['Chinese'],
      },
    },
    {
      '@type': 'WebPage',
      name: `关于我们 - ${siteConfig.name}`,
      url: `${siteConfig.url}/about`,
      description: `了解${siteConfig.name}的品牌故事、用户口碑与联系方式。${siteConfig.description}`,
      isPartOf: {
        '@type': 'WebSite',
        name: siteConfig.name,
        url: siteConfig.url,
      },
    },
  ],
};

export default function About() {
  return (
    <>
      <SEOHead
        title={`关于我们 - ${siteConfig.name}`}
        description={`了解${siteConfig.name}的品牌故事、用户口碑与联系方式。${siteConfig.description}`}
        keywords={`关于我们,品牌介绍,用户口碑,联系方式,${siteConfig.keywords}`}
        canonicalUrl={`${siteConfig.url}/about`}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />

      <Navbar />

      <main className="pt-20">
        <Breadcrumb
          items={[
            { label: '首页', path: '/' },
            { label: '关于我们' },
          ]}
        />

        <div className="w-full px-4 md:px-6 pb-14">
          <div className="max-w-7xl mx-auto mb-10">
            <h1 className="text-2xl md:text-4xl font-heading text-foreground-900 text-center">
              关于<span className="text-primary-500">{siteConfig.name}</span>
            </h1>
            <p className="text-sm text-secondary-500 text-center mt-3 max-w-lg mx-auto">
              致力于成为最优质的视频内容聚合导航平台
            </p>
          </div>

          <BrandIntro />
          <Reputation />
          <ContactSection />
        </div>
      </main>

      <Footer />
      <ScrollToTop />
    </>
  );
}